function formatCEP(cep: string) {
    // Remove todos os caracteres que não são dígitos
    const onlyNumbers = cep.replace(/\D/g, '');
  
    // Verifica se o CEP tem exatamente 8 dígitos
    if (onlyNumbers.length !== 8) {
      throw new Error('CEP inválido. O CEP deve conter exatamente 8 dígitos.');
    }
  
    // Insere o hífen após os 5 primeiros dígitos
    const formattedCEP = onlyNumbers.replace(/(\d{5})(\d{3})/, '$1-$2');
  
    return formattedCEP;
}

export default formatCEP;